import React from "react";
import { useSelector } from "react-redux";

// Components
import TextField from "@mui/material/TextField";
import Text from "components/common/Text";

// Libs
import Translation from "libs/Translation";

// Style
import { useStyles } from "./style";
import { Wrapper } from "./style";

const Input = ({
  errorText,
  error,
  handleChange,
  value,
  placeholder,
  readOnly,
  helperText,
  name,
  required,
  label,
  select,
  defaultValue,
  style,
  restInputProps,
  children,
  InputProps,
  disabled,
  type,
  desc,
  className,
  autoFocus,
}) => {
  const classes = useStyles();
  const { webConfig } = useSelector((state) => state.core);

  return (
    <Wrapper className="input-wrapper" dir={webConfig.dir}>
      {label && (
        <Text tag="span" className="label">
          {label} {required && <span>*</span>}
        </Text>
      )}
      {desc && (
        <Text tag="p" className="desc">
          {desc}
        </Text>
      )}
      <TextField
        variant="outlined"
        required={required}
        select={select}
        name={name}
        className={
          className ? className : error ? classes.helperText : classes.root
        }
        onChange={handleChange}
        value={type === "number" ? value : Translation.n(value)}
        error={error}
        placeholder={placeholder}
        helperText={helperText}
        defaultValue={
          type === "number" ? defaultValue : Translation.n(defaultValue)
        }
        style={{ direction: webConfig.dir, width: "100%", ...style }}
        disabled={disabled}
        readOnly={readOnly}
        type={type}
        autoFocus={autoFocus ?? false}
        sx={{
          "& .MuiSvgIcon-root": {
            right: "unset",
            left: "7px",
          },
        }}
        InputProps={{
          ...InputProps,
          ...restInputProps,
          classes: {
            root: classes.root,
            notchedOutline: error ? classes.error : classes.input,
          },
          autoComplete: "new-password",
          form: {
            autoComplete: "off",
          },
        }}
      >
        {children}
      </TextField>
      {errorText && <div className="error-text">{errorText}</div>}
    </Wrapper>
  );
};

export default Input;
